module.exports = __webpack_public_path__ + "static/media/card-VPY.1ac05457.svg";